/* @generated */

// src/assets/pictogram/info.tsx
import * as React from "react";
var InfoPictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M32 8C16.523 8 8 16.523 8 32s8.523 24 24 24 24-8.523 24-24S47.477 8 32 8Zm0 44c-13.271 0-20-6.729-20-20s6.729-20 20-20 20 6.729 20 20-6.729 20-20 20Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M32 22a1.857 1.857 0 0 0-2 2 2 2 0 0 0 4 0 1.857 1.857 0 0 0-2-2Zm-2 5.491V42h4V27.491a4.186 4.186 0 0 1-4 0Z",
    fill: "currentColor"
  }
));
export {
  InfoPictogram
};
